// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[data-v-d35df6f0]{max-width:40px}.values-wrapper[data-v-d35df6f0]{display:flex;font-size:18px;font-weight:lighter}.dash[data-v-d35df6f0]{text-align:center;width:16px}.el-slider__bar[data-v-d35df6f0]{background-color:#2f8e97!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
